import React from 'react'
import './user-dropdown.styles.scss'

import { Link } from 'react-router-dom'
import { version } from '@/changelog-version'
import { useSelector } from 'react-redux'

const UserDropdown = ({ show }) => {
    
    const root = useSelector(state => state.userData.root);
    const membership = useSelector(state => state.userData.membership);
    const screenSize = useSelector(state => state.contentData.screenSize);

    return (
        <div className={`auth-dropdown-container ${show ? 'active' : ''} ${screenSize}`}>
            <div className="auth-dropdown-menu">
                <Link 
                    to='/home' 
                    className='menu-item'>
                    My Games
                </Link>
                <Link 
                    to='/home/mycontent'
                    className='menu-item'>
                    My Content
                </Link>
                <Link 
                    to='/profile'
                    className='menu-item'>
                    My Profile
                </Link>
                <Link 
                    to='/myplan'
                    className='menu-item'>
                    My Plan
                </Link>
                <Link 
                    to ='/home/myorgs'
                    className='menu-item'>
                    My Organizations
                </Link>
                {/* {
                    (membership && membership.membership > 0) &&
                    <a href='https://billing.stripe.com/p/login/test_9AQ2aK2Nj3jaaYM9AA' target="_blank">Manage My Plan</a>
                } */}
                <Link 
                    to='/logout'
                    className='menu-item'>
                    Sign Out
                </Link>
                <div className='meta'>
                    <div className='version'>
                        {version}
                    </div>
                    <Link 
                        to='/changelog'
                        target='_blank'>
                        Change Log
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default UserDropdown